var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMouthQ(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 39,
    viewBox: "0 0 51 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.03991 0.721449C5.1939 0.191065 5.74869 -0.114069 6.27907 0.0399133C13.9769 2.27478 20.0018 3.35 26.0607 3.33776C32.123 3.32551 38.2768 2.22459 46.2351 0.0360541C46.7676 -0.110388 47.318 0.202587 47.4645 0.735103C47.6109 1.26762 47.2979 1.81802 46.7654 1.96446C38.7237 4.17593 32.3775 5.325 26.0648 5.33776C19.7487 5.35052 13.5236 4.22574 5.72145 1.96061C5.19106 1.80662 4.88593 1.25183 5.03991 0.721449Z",
    fill: "#181111"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00059 21.0175C21.8539 21.3688 35.2957 26.9879 36.8492 36.8772C37.0188 37.9564 36.0975 38.8542 35.0052 38.871C1.34659 39.3887 0.0518036 39.1027 0.00199354 23.0085C-0.00142454 21.904 0.896197 20.998 2.00059 21.0175Z",
    className: "Mouth"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9994 21.0175C29.1461 21.3688 15.7043 26.9879 14.1508 36.8772C13.9812 37.9564 14.9025 38.8542 15.9948 38.871C49.6534 39.3887 50.9482 39.1027 50.998 23.0085C51.0014 21.904 50.1038 20.998 48.9994 21.0175Z",
    className: "Mouth"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9176 28.9937C40.1657 34.1601 14.2788 34.508 2.82849 28.9937C-1.48834 26.9147 11.7238 16 27.1579 16C36.1833 16 55.8038 25.8753 49.9176 28.9937Z",
    className: "Mouth"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouthQ);
export default __webpack_public_path__ + "static/media/Mouth Q.a4a823ca55aa4d74720d3449fcf92510.svg";
export { ForwardRef as ReactComponent };